import { getAnalyticsData } from "../../repository/web/js/analytics.service";

export const getAnalyticsDataController = async (role, mainGymId) => {
  const analyticsData = await getAnalyticsData(role, mainGymId);
  return analyticsData;
};
